import script from "./InvestmentProperties.vue?vue&type=script&setup=true&lang=js"
export * from "./InvestmentProperties.vue?vue&type=script&setup=true&lang=js"

import "./InvestmentProperties.vue?vue&type=style&index=0&id=0c2c786a&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0c2c786a"]])

export default __exports__